<div class="wrapper bg-area" *ngIf="!isMobile">
  <section id="dados-pessoais">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column is-6">
          <h3 class="title">Monte seu Plano</h3>
          <div class="bar__container">
            <ul class="bar" id="bar">
              <li class="active active-step"><i class="fas fa-check"></i>Plano</li>
              <li>Dados Pessoais</li>
              <li>Pagamento</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="sample-form">
        <div class="body-faca-parte columns">
          <div class="column is-6">

            <form [formGroup]="form" class="dados-pessoais">

              <h4>INSIRA SEUS DADOS PESSOAIS</h4>
              <p>Você está a <strong>2 passos</strong> de se Cadastrar no Clube!</p>
<!--              <div class="field forms-dados" tabindex="1">-->
<!--                <input formControlName="nome" [class]="fieldCssClass(form, 'nome')" name="nome" type="text"-->
<!--                  placeholder="Nome Completo"  required>-->
<!--                <span class="campo-erro" *ngIf="showError('nome')">{{getErrorMessage('nome')}}</span>-->
<!--              </div>-->

<!--              <div class="field forms-dados" tabindex="1">-->
<!--                <input formControlName="celular" [class]="fieldCssClass(form, 'celular')" name="celular" type="tel"-->
<!--                   mask="(00) 00000-0000" placeholder="Celular"-->
<!--                  mask-output="alphanumeric" required>-->
<!--                <span class="campo-erro" *ngIf="showError('celular')">{{getErrorMessage('celular')}}</span>-->
<!--              </div>-->

              <div class="field forms-dados" tabindex="1">
                <input formControlName="cpf" [class]="fieldCssClass(form, 'cpf')" (focusout)="validaExistCpf($event)"
                  name="cpf" type="cpf" mask="000.000.000-00" placeholder="CPF" mask-output="alphanumeric" required>
                <span class="campo-erro" *ngIf="showError('cpf')">{{getErrorMessage('cpf')}}</span>
              </div>

              <div class="field forms-dados" tabindex="1">
                <input formControlName="dataNascimento" [class]="fieldCssClass(form, 'dataNascimento')"
                  mask="00/00/0000" name="dataNascimento" type="text" placeholder="Data de Nascimento" required>
                <span class="campo-erro"
                  *ngIf="showError('dataNascimento')">{{getErrorMessage('dataNascimento')}}</span>
              </div>

<!--              <label class="email" name="email">E-mail</label>-->
<!--              <div class="field forms-dados" tabindex="1">-->
<!--                <input *ngIf="!propostaAndamento" [class]="fieldCssClass(form, 'email')" formControlName="email"-->
<!--                  name="email" type="email" placeholder="E-mail" required>-->
<!--                <input *ngIf="propostaAndamento" [class]="fieldCssClass(form, 'email')" disabled="disabled"-->
<!--                  formControlName="email" name="email" type="email" placeholder="E-mail" required>-->
<!--                <span class="campo-erro" *ngIf="showError('email')">{{getErrorMessage('email')}}</span>-->
<!--              </div>-->

<!--              <div class="field forms-dados" tabindex="1">-->
<!--                <input formControlName="confirmaEmail" [class]="fieldCssClass(form, 'confirmaEmail')" name="email"-->
<!--                  type="email" placeholder="Confirmação de E-mail" required>-->
<!--                <span class="campo-erro" *ngIf="showError('confirmaEmail')">{{getErrorMessage('confirmaEmail')}}</span>-->
<!--              </div>-->

              <p class="opcao-cobranca"><strong>ENDEREÇO DE COBRANÇA</strong></p>

              <div class="field forms-dados" tabindex="1">
                <input formControlName="cep" [class]="fieldCssClass(form, 'cep')" (focusout)="buscarCepVia($event, form)"
                       name="cep" type="text" placeholder="CEP" mask="00000-000" mask-output="alphanumeric" required>
                <span class="campo-erro" *ngIf="showError('cep')">{{getErrorMessage('cep')}}</span>
              </div>

              <div class="field forms-dados" tabindex="1">
                <input formControlName="endereco" [class]="fieldCssClass(form, 'endereco')"
                       name="endereco" type="text" placeholder="Endereço" required>
                <span class="campo-erro" *ngIf="showError('endereco')">{{getErrorMessage('endereco')}}</span>
              </div>

              <div class="field forms-dados" tabindex="1">
                <input formControlName="bairro" [class]="fieldCssClass(form, 'bairro')"
                       name="bairro" type="text" placeholder="Bairro" required maxlength="35">
                <span class="campo-erro" *ngIf="showError('bairro')">{{getErrorMessage('bairro')}}</span>
              </div>

              <div class="field forms-dados" tabindex="1">
                <input formControlName="numero" [class]="fieldCssClass(form, 'numero')" name="numero" type="text" placeholder="Número">
                <span class="campo-erro" *ngIf="showError('numero')">{{getErrorMessage('numero')}}</span>
              </div>

              <div class="field forms-dados" tabindex="1">
                <input formControlName="complemento" [class]="fieldCssClass(form, 'complemento')" name="complemento"
                       type="text" placeholder="Complemento">
                <span class="campo-erro" *ngIf="showError('complemento')">{{getErrorMessage('complemento')}}</span>
              </div>

              <span class="voce-seguro">
                Seus dados só serão utilizados para comunicação entre a Montreal e você e jamais
                serão divulgados a terceiros.
              </span>

              <div class="captcha" tabindex="1">
                <ngx-recaptcha2 #captchaElem
                                [siteKey]="'6LcWJW8eAAAAAN6e3qBV1_N8nApyPFWCDIJeSxgD'"
                                (success)="handleSuccess($event)"
                                (load)="handleLoad($event)"
                                (error)="handleError($event)"
                                [size]="'normal'"
                                [hl]="'pt-br'"
                                [theme]="'light'"
                                [type]="'image'"
                                [useGlobalDomain]="false"
                                formControlName="recaptcha"></ngx-recaptcha2>
              </div>

            </form>
          </div>
          <div class="column is-6 resumo-compra">
              <app-resumo [result]="propostaResult" [totalDiarias]="countDiarias">

                <button [disabled]="form.invalid" type="button" [class]="form.invalid ? 'btn-desabilitado' : 'btn-verde'"
                        (click)="cadastraDadosCliente()">CONTINUAR</button>
              </app-resumo>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div *ngIf="UserCPF"
    [class]="UserCPF && UserCPF.isCliente && !UserCPF.exCliente && !UserCPF.temPropostaAberta ? 'modal is-active' : 'modal'">
    <div class="aviso">
      <div class="revise-dados">
        <h3>Hey, {{UserCPF.primeiroNome}}!</h3>
        <a (click)='limparCpf()' class="link-verde">Não sou {{UserCPF.primeiroNome}}</a>
        <p>Identificamos pelo seu CPF que você já é um Cliente Montreal. Para agilizar sua compra, faça seu Login e
          compre em Apenas Um Clique!</p>

        <a [routerLink]="['/login']" class="btn-verde">FAZER LOGIN</a>
      </div>
    </div>
  </div>

  <div *ngIf="UserCPF"
    [class]="UserCPF && UserCPF.isCliente && UserCPF.exCliente && !UserCPF.temPropostaAberta ? 'modal is-active' : 'modal'">
    <div class="aviso">
      <div class="revise-dados">
        <h3>Hey, {{UserCPF.primeiroNome}}!</h3>
        <a (click)='limparCpf()' class="link-verde">Não sou {{UserCPF.primeiroNome}}</a>
        <p>Identificamos pelo seu CPF que você já foi um Cliente Montreal. Para Continuar, vou precisar que efetue login
          com a mesma senha que você usava no Portal do Cliente!</p>

        <a [routerLink]="['/login']" class="btn-verde">FAZER LOGIN</a>
      </div>
    </div>
  </div>

  <div *ngIf="UserCPF" [class]="UserCPF && UserCPF.temPropostaAberta ? 'modal is-active' : 'modal'">
    <div class="aviso">
      <div class="revise-dados">
        <h3>Hey, {{UserCPF.primeiroNome}}!</h3>
        <a (click)='limparCpf()' class="link-verde">Não sou {{UserCPF.primeiroNome}}</a>
        <p>Identificamos pelo CPF informado que você já tem uma proposta aberta.<br>Dúvidas? <a class="link-verde"
            [routerLink]="['/contatos']">Entre em contato</a></p>
      </div>
    </div>
  </div>
</div>
<div class="wrapper bg-area" *ngIf="isMobile">
  <section id="dados-pessoais-mobile" >
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column is-6">
          <div class="title">
            <h3>INSIRA SEUS DADOS PESSOAIS</h3>
          </div>
          <div class="subtitle">
            <h4>Você está a <strong>2 passos</strong> de se Cadastrar no Clube!</h4>
          </div>
          <form [formGroup]="form" class="dados-pessoais">
<!--            <div class="field forms-dados" tabindex="1">-->
<!--              <input formControlName="nome"-->
<!--                     [class]="fieldCssClass(form, 'nome')"-->
<!--                     name="nome"-->
<!--                     type="text"-->
<!--                     placeholder="Nome Completo"-->
<!--                     required>-->
<!--              <span class="campo-erro" *ngIf="showError('nome')">{{getErrorMessage('nome')}}</span>-->
<!--            </div>-->
<!--            <div class="field forms-dados" tabindex="1">-->
<!--              <input formControlName="celular"-->
<!--                     [class]="fieldCssClass(form, 'celular')"-->
<!--                     name="celular"-->
<!--                     type="tel"-->
<!--                     mask="(00) 00000-0000"-->
<!--                     placeholder="Celular"-->
<!--                     mask-output="alphanumeric"-->
<!--                     required>-->
<!--              <span class="campo-erro" *ngIf="showError('celular')">{{getErrorMessage('celular')}}</span>-->
<!--            </div>-->
            <div class="field forms-dados" tabindex="1">
              <input formControlName="cpf"
                     [class]="fieldCssClass(form, 'cpf')"
                     (focusout)="validaExistCpf($event)"
                     name="cpf"
                     type="cpf"
                     mask="000.000.000-00"
                     placeholder="CPF"
                     mask-output="alphanumeric"
                     required>
              <span class="campo-erro" *ngIf="showError('cpf')">{{getErrorMessage('cpf')}}</span>
            </div>
            <div class="field forms-dados" tabindex="1">
              <input formControlName="dataNascimento"
                     [class]="fieldCssClass(form, 'dataNascimento')"
                     mask="00/00/0000"
                     name="dataNascimento"
                     type="text"
                     placeholder="Data de Nascimento"
                     required>
              <span class="campo-erro" *ngIf="showError('dataNascimento')">{{getErrorMessage('dataNascimento')}}</span>
            </div>
<!--            <div class="field forms-dados" tabindex="1">-->
<!--              <label class="email" name="email">E-mail</label>-->
<!--              <input *ngIf="!propostaAndamento"-->
<!--                     [class]="fieldCssClass(form, 'email')"-->
<!--                     formControlName="email"-->
<!--                     name="email"-->
<!--                     type="email"-->
<!--                     placeholder="E-mail"-->
<!--                     required>-->
<!--              <input *ngIf="propostaAndamento"-->
<!--                     [class]="fieldCssClass(form, 'email')"-->
<!--                     disabled="disabled"-->
<!--                     formControlName="email"-->
<!--                     name="email"-->
<!--                     type="email"-->
<!--                     placeholder="E-mail"-->
<!--                     required>-->
<!--              <span class="campo-erro" *ngIf="showError('email')">{{getErrorMessage('email')}}</span>-->
<!--            </div>-->
<!--            <div class="field forms-dados" tabindex="1">-->
<!--              <input formControlName="confirmaEmail"-->
<!--                     [class]="fieldCssClass(form, 'confirmaEmail')"-->
<!--                     name="email"-->
<!--                     type="email"-->
<!--                     placeholder="Confirmação de E-mail"-->
<!--                     required>-->
<!--              <span class="campo-erro" *ngIf="showError('confirmaEmail')">{{getErrorMessage('confirmaEmail')}}</span>-->
<!--            </div>-->

            <p class="opcao-cobranca"><strong>ENDEREÇO DE COBRANÇA</strong></p>

            <div class="field forms-dados" tabindex="1">
              <input formControlName="cep"
                     [class]="fieldCssClass(form, 'cep')"
                     (focusout)="buscarCepVia($event, form)"
                     name="cep"
                     type="text"
                     placeholder="CEP"
                     mask="00000-000"
                     mask-output="alphanumeric"
                     required>
              <span class="campo-erro" *ngIf="showError('cep')">{{getErrorMessage('cep')}}</span>
            </div>

            <div class="field forms-dados" tabindex="1">
              <input formControlName="endereco" [class]="fieldCssClass(form, 'endereco')"
                     name="endereco" type="text" placeholder="Endereço" required>
              <span class="campo-erro" *ngIf="showError('endereco')">{{getErrorMessage('endereco')}}</span>
            </div>

            <div class="field forms-dados" tabindex="1">
              <input formControlName="bairro" [class]="fieldCssClass(form, 'bairro')"
                     name="bairro" type="text" placeholder="Bairro" required maxlength="35">
              <span class="campo-erro" *ngIf="showError('bairro')">{{getErrorMessage('bairro')}}</span>
            </div>

            <div class="field forms-dados" tabindex="1">
              <input formControlName="numero" [class]="fieldCssClass(form, 'numero')" name="numero" type="text" placeholder="Número">
              <span class="campo-erro" *ngIf="showError('numero')">{{getErrorMessage('numero')}}</span>
            </div>

            <div class="field forms-dados" tabindex="1">
              <input formControlName="complemento" [class]="fieldCssClass(form, 'complemento')" name="complemento"
                     type="text" placeholder="Complemento">
              <span class="campo-erro" *ngIf="showError('complemento')">{{getErrorMessage('complemento')}}</span>
            </div>

            <span class="voce-seguro">
              Seus dados só serão utilizados para comunicação entre
              a Montreal e você e jamais serão divulgados a terceiros.
            </span>

            <div class="captcha" tabindex="1">
              <ngx-recaptcha2 #captchaElem
                              [siteKey]="'6LcWJW8eAAAAAN6e3qBV1_N8nApyPFWCDIJeSxgD'"
                              (success)="handleSuccess($event)"
                              (load)="handleLoad($event)"
                              (error)="handleError($event)"
                              [size]="'normal'"
                              [hl]="'pt-br'"
                              [theme]="'light'"
                              [type]="'image'"
                              [useGlobalDomain]="false"
                              formControlName="recaptcha"></ngx-recaptcha2>
            </div>
          </form>
          <div class="column is-6 resumo-compra" *ngIf="propostaResult">
            <div class="area-fixed-resumo" *ngIf="isMobile">
              <div class="seu-plano">
                <div class="total">
                  <div>
                    <h4>
                      <strong>Valor do Plano</strong>
                    </h4>
                    <p class="valor-plano">
                        <span class="valor">
                      <small></small>
                          {{propostaResult && propostaResult.valorMensalidadeDesconto && propostaResult.valorMensalidadeDesconto.toString() != 'R$ 0,00' ? propostaResult.valorMensalidadeDesconto : propostaResult.valorMensalidade.toString()}}
                          /
                      <span>mês</span>
                      </span>
                    </p>
                  </div>

                  <div class="btn-mobile">
                    <button [disabled]="form.invalid"
                            type="button"
                            [class]="form.invalid ? 'btn-desabilitado' : 'btn-verde'"
                            (click)="cadastraDadosCliente()"
                            class="btn-verde">
                      CONTINUAR
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div *ngIf="UserCPF"
    [class]="UserCPF && UserCPF.isCliente && !UserCPF.exCliente && !UserCPF.temPropostaAberta ? 'modal is-active' : 'modal'">
    <div class="aviso">
      <div class="revise-dados">
        <h3>Hey, {{UserCPF.primeiroNome}}!</h3>
        <a (click)='limparCpf()' class="link-verde">Não sou {{UserCPF.primeiroNome}}</a>
        <p>Identificamos pelo seu CPF que você já é um Cliente Montreal. Para agilizar sua compra, faça seu Login e
          compre em Apenas Um Clique!</p>

        <a [routerLink]="['/login']" class="btn-verde">FAZER LOGIN</a>
      </div>
    </div>
  </div>

  <div *ngIf="UserCPF"
    [class]="UserCPF && UserCPF.isCliente && UserCPF.exCliente && !UserCPF.temPropostaAberta ? 'modal is-active' : 'modal'">
    <div class="aviso">
      <div class="revise-dados">
        <h3>Hey, {{UserCPF.primeiroNome}}!</h3>
        <a (click)='limparCpf()' class="link-verde">Não sou {{UserCPF.primeiroNome}}</a>
        <p>Identificamos pelo seu CPF que você já foi um Cliente Montreal. Para Continuar, vou precisar que efetue login
          com a mesma senha que você usava no Portal do Cliente!</p>

        <a [routerLink]="['/login']" class="btn-verde">FAZER LOGIN</a>
      </div>
    </div>
  </div>

  <div *ngIf="UserCPF" [class]="UserCPF && UserCPF.temPropostaAberta ? 'modal is-active' : 'modal'">
    <div class="aviso">
      <div class="revise-dados">
        <h3>Hey, {{UserCPF.primeiroNome}}!</h3>
        <a (click)='limparCpf()' class="link-verde">Não sou {{UserCPF.primeiroNome}}</a>
        <p>Identificamos pelo CPF informado que você já tem uma proposta aberta.<br>Dúvidas? <a class="link-verde"
            [routerLink]="['/contatos']">Entre em contato</a></p>
      </div>
    </div>
  </div>
</div>
